<p-dialog [(visible)]="isMessageModal" [style]="{width: '50vw',maxHeight: '30vh'}" class="msgText" (onHide)="cancel()" [modal]="true">
        <ng-template pTemplate="header">
            <b>{{headerTxt}}</b>
        </ng-template>
        <div class="field">
            <p>{{messageTxt}}</p>
        </div>
</p-dialog>
